import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  PageHeader,
  Phone,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import useMotorista, { LOAD_MESSAGE } from './MotoristaHook'
import MotoristaModal from './MotoristaModal/MotoristaModal'
import { FaExclamationTriangle } from 'react-icons/fa'

const Motorista = ({ history, dispatch, selectedTp }) => {
  const { state, localDispatch } = useMotorista()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getMotoristas(state.selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.motoristas)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )

  return (
    <div>
      <PageHeader>2.4 - Cadastro de Motoristas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={localDispatch.onBtnNovo} onVoltar={history.goBack}>
          <DataTable
            rows={10}
            paginator
            value={state.motoristas}
            selectionMode="single"
            onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
            header={header}
            globalFilter={state.globalFilter}
            emptyMessage={'Não existem motoristas cadastrados . . . '}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} />
            <Column field="name" header="Nome" />
            <Column field="cnh_number" header="Núm. CNH" style={tableCellCentered(130)} />
            <Column field="cnh_type" header="Categoria - CNH" style={tableCellCentered(150)} />
            <Column
              field="cnh_expiration"
              header="Vencimento - CNH"
              style={tableCellCentered(190)}
              sortable
              body={({ cnh_expiration }) => {
                const cnh_date = new Date(cnh_expiration)
                const currentDate = new Date()

                const differenceInTime = cnh_date.getTime() - currentDate.getTime()
                const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24))

                if (!cnh_expiration) return ''

                if (differenceInDays <= 30)
                  return (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <DateTime>{cnh_expiration}</DateTime>
                      <FaExclamationTriangle color="red" style={{ marginLeft: 3 }} />
                    </div>
                  )
                if (differenceInDays <= 60)
                  return (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <DateTime>{cnh_expiration}</DateTime>
                      <FaExclamationTriangle color="orange" style={{ marginLeft: 3 }} />
                    </div>
                  )
                return <DateTime>{cnh_expiration}</DateTime>
              }}
            />
            <Column
              field="toxicologico_expiration"
              header="Vencimento - Toxicológico"
              style={tableCellCentered(170)}
              sortable
              body={({ toxicologico_expiration }) => {
                const cnh_date = new Date(toxicologico_expiration)
                const currentDate = new Date()
                const differenceInTime = cnh_date.getTime() - currentDate.getTime()
                const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24))
                if (!toxicologico_expiration) return ''
                if (differenceInDays <= 30)
                  return (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <DateTime>{toxicologico_expiration}</DateTime>
                      <FaExclamationTriangle color="red" style={{ marginLeft: 3 }} />
                    </div>
                  )
                if (differenceInDays <= 60)
                  return (
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <DateTime>{toxicologico_expiration}</DateTime>
                      <FaExclamationTriangle color="orange" style={{ marginLeft: 3 }} />
                    </div>
                  )
                return <DateTime>{toxicologico_expiration}</DateTime>
              }}
            />
            <Column
              field="phone"
              header="Telefone"
              style={tableCellCentered(130)}
              body={motorista => <Phone>{motorista.phone}</Phone>}
            />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered(80)}
              body={motorista => <CustomCheckbox onChange={() => {}} checked={motorista.actived} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <MotoristaModal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        motorista={state.modal.data}
        selectedTp={state.selectedTp}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Motorista))
